
/**
 *   String substitution based on <KEY> -> VALUE. 
 *   There's only on example right now -- if it becomes a common practice, we can move this into java code
 *   so that strings are substituted in the API feed too; for now, the angle brackets should be enough to hide
 *   in web pages.
 *   
 *   DO NOT INCLUDE JQUERY in this file -- it's being used on the server too.
 */

var projectTags = [];
projectTags.push({"key":"<profdevpilot>|<<em>profdevpilot</em>>","search":"<i style=\"font-style:italic\">This project is part of a pilot program.</i>","default":"<i style=\"font-style:italic\">This project is part of a <a target=\"_blank\" href=\"https://help.donorschoose.org/hc/en-us/articles/204363783\">pilot program</a>.</i>"});
projectTags.push({"key":"Teacher Professional Development","search":"<strong>Professional Development</strong>","default":"<strong>Professional Development</strong>"});
projectTags.push({"key":"<teachplanet15>|<<em>teachplanet15</em>>","search":"<i style=\"font-style:italic\">This project is part of the replication phase for the Teach for the Planet challenge.</i>","default":"<i style=\"font-style:italic\">This project is part of the replication phase for the <a target=\"_blank\" href=\""+baseURL+"tftpreplications\">Teach for the Planet challenge</a>.</i>"});


export function substituteProjectTags(str, replaceOption) {
	if (typeof str == "undefined" || str == null || str.length == 0) return "";
	var replaceOption = replaceOption || "default";
	for (var i = 0; i < projectTags.length; i++) {
		if (projectTags[i][replaceOption] != null) {
			var re = new RegExp(projectTags[i].key,"gim");
			str = " " + str.replace(re,projectTags[i][replaceOption]);
		}
	}
	return str;
}

